export enum AppRoutes {
    Home = "/",

    SignIn = "/prijava",
    SignInAd = "/prijava-active-directory",
    SignUp = "/registracija",
    Unauthorized = "/neovlasteno",

    ForgotPassword = "/zaboravljena-lozinka",
    ChangePassword = "/nova-lozinka",
    ActivateAccount = "/aktivacija-racuna",
    Education = "/tecajevi",
    News = "/vijesti-i-savjeti",
    AgroclimateStations = "/agroklimatske-stanice",
    Agrometeorology = "/agrometeorologija",
    Records = "/evidencije",
    PlantProtection = "/zastita-bilja",
    UserActivity = "/aktivnost-korisnika",
    UserAdministration = "/administracija-korisnika",
    ActiveDirectoryUsers = "/ad-korisnici",
    Profile = "/profil",
    SystemAdministration = "/administracija-sustava",
    NotAuthorized = "/unauthorized",
    Presentations = "/", //prezentacije
    Communication = "/komunikacija-s-korisnicima",
    UserNotifications = "/moje-poruke",
    ModulesAdministration = "/administracija-modula",
    ModuleVersionsAdministration = "/administracija-verzija-modula",
    Beekeeping = "/moje-pcelarstvo",

    // internal systems
    ExternalModules = "/vanjski-moduli",
    EducationAnalysis = "/analiza-edukacija",
    SemisAdministrationModule = "/semis-administracija",

    Codebook = "/sifrarnik", // evidencije
    PhytoViewAdministration = "/phytoview-administracija",
    EducationDocuments = "/dokumenti-edukacija",
    MobileAppPortal = "/mobilne-aplikacije",

    // Agrosenzorika
    InteractiveMap = "/interaktivna-karta",
    MySensorics = "/moja-senzorika",
}

export enum RouteParams {
    EducationId = "educationId",
    RecordId = "recordId",
    NewsId = "newsId",
    AdviceId = "adviceId",
    RecommendationId = "recommendationId",
    NotificationId = "notificationId",
}
